export default __webpack_public_path__ + "static/media/Dosis-Bold.da853f58.ttf";